type Currency = {
	uuid: string;
	label: string;
	value: string;
};

export const currencies: Currency[] = [
	{
		uuid: "9fc5d890-c944-4222-95ff-642388d11222",
		label: "Afghan Afghani (AFN)",
		value: "AFN",
	},
	{
		uuid: "9fc5d890-c94d-4998-83a7-93eed832fce2",
		label: "Albanian Lek (ALL)",
		value: "ALL",
	},
	{
		uuid: "9fc5d890-c950-464b-9c01-62194db4fbed",
		label: "Algerian Dinar (DZD)",
		value: "DZD",
	},
	{
		uuid: "9fc5d890-c952-401c-9cf7-0c12ad4d1139",
		label: "Angolan Kwanza (AOA)",
		value: "AOA",
	},
	{
		uuid: "9fc5d890-c953-43e9-9aef-308afb9bf64c",
		label: "Argentine Peso (ARS)",
		value: "ARS",
	},
	{
		uuid: "9fc5d890-c955-482d-aec9-4563d51f2ef4",
		label: "Armenian Dram (AMD)",
		value: "AMD",
	},
	{
		uuid: "9fc5d890-c957-4771-85ae-762db3a68df0",
		label: "Aruban Florin (AWG)",
		value: "AWG",
	},
	{
		uuid: "9fc5d890-c958-4004-9717-8ce921ed092d",
		label: "Australian Dollar (AUD)",
		value: "AUD",
	},
	{
		uuid: "9fc5d890-c95a-46b3-b965-15ba0c843306",
		label: "Azerbaijani Manat (AZN)",
		value: "AZN",
	},
	{
		uuid: "9fc5d890-c95b-493b-a8a2-3265193dc52f",
		label: "Bahamian Dollar (BSD)",
		value: "BSD",
	},
	{
		uuid: "9fc5d890-c95d-4a58-8b09-b3cc40aaedc2",
		label: "Bahraini Dinar (BHD)",
		value: "BHD",
	},
	{
		uuid: "9fc5d890-c95e-4feb-8f84-96627266f9f6",
		label: "Bangladeshi Taka (BDT)",
		value: "BDT",
	},
	{
		uuid: "9fc5d890-c960-488d-994e-1221168675b2",
		label: "Barbadian Dollar (BBD)",
		value: "BBD",
	},
	{
		uuid: "9fc5d890-c961-40b1-bfc9-67c5e1af80b8",
		label: "Belize Dollar (BZD)",
		value: "BZD",
	},
	{
		uuid: "9fc5d890-c963-4b34-9f70-79ce5db10430",
		label: "Bermudan Dollar (BMD)",
		value: "BMD",
	},
	{
		uuid: "9fc5d890-c964-423f-8a6d-84e5fbf49ba9",
		label: "Bhutanese Ngultrum (BTN)",
		value: "BTN",
	},
	{
		uuid: "9fc5d890-c966-4907-9e09-0767c0019039",
		label: "Bolivian Boliviano (BOB)",
		value: "BOB",
	},
	{
		uuid: "9fc5d890-c968-4e3e-a5f8-1e4294c44800",
		label: "Bosnia-Herzegovina Convertible Mark (BAM)",
		value: "BAM",
	},
	{
		uuid: "9fc5d890-c969-407a-9dc0-af1e9f93dd85",
		label: "Botswanan Pula (BWP)",
		value: "BWP",
	},
	{
		uuid: "9fc5d890-c96b-4f5a-8c33-08dbd62e7ec9",
		label: "Brazilian Real (BRL)",
		value: "BRL",
	},
	{
		uuid: "9fc5d890-c96c-44f4-946b-2706d457ff45",
		label: "British Pound Sterling (GBP)",
		value: "GBP",
	},
	{
		uuid: "9fc5d890-c96e-4805-b60b-a896db52698a",
		label: "Brunei Dollar (BND)",
		value: "BND",
	},
	{
		uuid: "9fc5d890-c96f-4531-a510-fe5570a99db1",
		label: "Bulgarian Lev (BGN)",
		value: "BGN",
	},
	{
		uuid: "9fc5d890-c971-41e7-9f4b-14bee42a61a6",
		label: "Burundian Franc (BIF)",
		value: "BIF",
	},
	{
		uuid: "9fc5d890-c972-40ae-94e7-f33c87b3001b",
		label: "Cambodian Riel (KHR)",
		value: "KHR",
	},
	{
		uuid: "9fc5d890-c974-41dc-aa58-e1cd1f691598",
		label: "Canadian Dollar (CAD)",
		value: "CAD",
	},
	{
		uuid: "9fc5d890-c975-43e8-9c2d-3a1c16c04172",
		label: "Cape Verdean Escudo (CVE)",
		value: "CVE",
	},
	{
		uuid: "9fc5d890-c978-414c-8891-3297a670019c",
		label: "Cayman Islands Dollar (KYD)",
		value: "KYD",
	},
	{
		uuid: "9fc5d890-c97a-4ed3-83f2-de8540d770e2",
		label: "CFA Franc BCEAO (XOF)",
		value: "XOF",
	},
	{
		uuid: "9fc5d890-c97b-4066-9990-0dc425cf3e95",
		label: "CFA Franc BEAC (XAF)",
		value: "XAF",
	},
	{
		uuid: "9fc5d890-c97d-4f02-a5d1-ab3ae87d2bdc",
		label: "CFP Franc (XPF)",
		value: "XPF",
	},
	{
		uuid: "9fc5d890-c97e-4b05-9576-30b944775db2",
		label: "Chilean Peso (CLP)",
		value: "CLP",
	},
	{
		uuid: "9fc5d890-c980-4347-9e3d-cd2d1181bbdf",
		label: "Chinese Yuan (CNY)",
		value: "CNY",
	},
	{
		uuid: "9fc5d890-c981-4cde-a494-aa36074cc228",
		label: "Colombian Peso (COP)",
		value: "COP",
	},
	{
		uuid: "9fc5d890-c983-4d8b-8c89-c75f46227074",
		label: "Comorian Franc (KMF)",
		value: "KMF",
	},
	{
		uuid: "9fc5d890-c984-41a0-a12e-041bcba5c152",
		label: "Congolese Franc (CDF)",
		value: "CDF",
	},
	{
		uuid: "9fc5d890-c986-4e5f-8c71-73eb1598a4af",
		label: "Costa Rican Colón (CRC)",
		value: "CRC",
	},
	{
		uuid: "9fc5d890-c987-430e-a431-2d5ef787ecf2",
		label: "Croatian Kuna (HRK)",
		value: "HRK",
	},
	{
		uuid: "9fc5d890-c989-49fd-b2c2-ac144393b209",
		label: "Cuban Convertible Peso (CUC)",
		value: "CUC",
	},
	{
		uuid: "9fc5d890-c98a-4e61-bf4f-fa0e867cd3aa",
		label: "Cuban Peso (CUP)",
		value: "CUP",
	},
	{
		uuid: "9fc5d890-c98c-4d69-ab44-423d2729b288",
		label: "Czech Republic Koruna (CZK)",
		value: "CZK",
	},
	{
		uuid: "9fc5d890-c98d-42a0-a9b7-7b699fd4159a",
		label: "Danish Krone (DKK)",
		value: "DKK",
	},
	{
		uuid: "9fc5d890-c98f-442e-9e9b-45d8f0f9122f",
		label: "Djiboutian Franc (DJF)",
		value: "DJF",
	},
	{
		uuid: "9fc5d890-c990-47c8-beb7-dfba0c92dde1",
		label: "Dominican Peso (DOP)",
		value: "DOP",
	},
	{
		uuid: "9fc5d890-c992-453c-b4bf-75832dcf88af",
		label: "East Caribbean Dollar (XCD)",
		value: "XCD",
	},
	{
		uuid: "9fc5d890-c993-45d1-9856-ef5f02b5b631",
		label: "Egyptian Pound (EGP)",
		value: "EGP",
	},
	{
		uuid: "9fc5d890-c995-480c-8043-7903f5417d7f",
		label: "Eritrean Nakfa (ERN)",
		value: "ERN",
	},
	{
		uuid: "9fc5d890-c99a-4807-ac7c-14b7a3d2678a",
		label: "Ethiopian Birr (ETB)",
		value: "ETB",
	},
	{
		uuid: "9fc5d890-c99b-4741-8610-c1a4729121c3",
		label: "Euro (EUR)",
		value: "EUR",
	},
	{
		uuid: "9fc5d890-c99d-47de-addc-cda6777b0b8b",
		label: "Falkland Islands Pound (FKP)",
		value: "FKP",
	},
	{
		uuid: "9fc5d890-c99f-48da-a328-2b7f8490b2d9",
		label: "Fijian Dollar (FJD)",
		value: "FJD",
	},
	{
		uuid: "9fc5d890-c9a1-460b-a324-1e70ba5f01fa",
		label: "Gambian Dalasi (GMD)",
		value: "GMD",
	},
	{
		uuid: "9fc5d890-c9a2-4b01-835f-c9d1ace272bc",
		label: "Georgian Lari (GEL)",
		value: "GEL",
	},
	{
		uuid: "9fc5d890-c9a4-456e-a96e-58b07fd072c8",
		label: "Ghanaian Cedi (GHS)",
		value: "GHS",
	},
	{
		uuid: "9fc5d890-c9a5-4429-8659-56e4f0bdc3ee",
		label: "Gibraltar Pound (GIP)",
		value: "GIP",
	},
	{
		uuid: "9fc5d890-c9a7-428b-86a4-393154d6a5ce",
		label: "Guatemalan Quetzal (GTQ)",
		value: "GTQ",
	},
	{
		uuid: "9fc5d890-c9a8-4efc-a575-d554924973e2",
		label: "Guinean Franc (GNF)",
		value: "GNF",
	},
	{
		uuid: "9fc5d890-c9aa-4525-8e41-a1ee389edb81",
		label: "Guyanaese Dollar (GYD)",
		value: "GYD",
	},
	{
		uuid: "9fc5d890-c9ad-4559-b6a8-ed6eb6b2b3a5",
		label: "Haitian Gourde (HTG)",
		value: "HTG",
	},
	{
		uuid: "9fc5d890-c9ae-4f51-a6f0-4598993fe390",
		label: "Honduran Lempira (HNL)",
		value: "HNL",
	},
	{
		uuid: "9fc5d890-c9af-454e-90c1-ae24b3372ef8",
		label: "Hong Kong Dollar (HKD)",
		value: "HKD",
	},
	{
		uuid: "9fc5d890-c9b2-4b82-b1bf-4b3b9b205f13",
		label: "Hungarian Forint (HUF)",
		value: "HUF",
	},
	{
		uuid: "9fc5d890-c9b4-4489-80ab-d7a18fa44748",
		label: "Icelandic Króna (ISK)",
		value: "ISK",
	},
	{
		uuid: "9fc5d890-c9b5-4267-a833-640126a725f0",
		label: "Indian Rupee (INR)",
		value: "INR",
	},
	{
		uuid: "9fc5d890-c9b6-4618-9fa5-3b755ff34900",
		label: "Indonesian Rupiah (IDR)",
		value: "IDR",
	},
	{
		uuid: "9fc5d890-c9b8-484f-a0b1-1f854f0a4ac0",
		label: "Iranian Rial (IRR)",
		value: "IRR",
	},
	{
		uuid: "9fc5d890-c9b9-4cfb-b6e9-f4f09945f727",
		label: "Iraqi Dinar (IQD)",
		value: "IQD",
	},
	{
		uuid: "9fc5d890-c9ba-4e76-9d5d-487c52f54154",
		label: "Israeli New Sheqel (ILS)",
		value: "ILS",
	},
	{
		uuid: "9fc5d890-c9bc-4e3e-8065-a6530b437ca3",
		label: "Jamaican Dollar (JMD)",
		value: "JMD",
	},
	{
		uuid: "9fc5d890-c9bd-4ad9-a05a-f9cfc8b386d0",
		label: "Japanese Yen (JPY)",
		value: "JPY",
	},
	{
		uuid: "9fc5d890-c9be-4bc7-8c2c-1098818d1163",
		label: "Jordanian Dinar (JOD)",
		value: "JOD",
	},
	{
		uuid: "9fc5d890-c9c0-4520-9c55-79295f2d3658",
		label: "Kazakhstani Tenge (KZT)",
		value: "KZT",
	},
	{
		uuid: "9fc5d890-c9c1-4429-a3b6-4b3c5993d14a",
		label: "Kenyan Shilling (KES)",
		value: "KES",
	},
	{
		uuid: "9fc5d890-c9c2-4676-93be-0793a9b895d3",
		label: "Kuwaiti Dinar (KWD)",
		value: "KWD",
	},
	{
		uuid: "9fc5d890-c9c4-4cb2-b6c1-4f00cfdb70c8",
		label: "Kyrgystani Som (KGS)",
		value: "KGS",
	},
	{
		uuid: "9fc5d890-c9c5-4cc7-9af0-1aa498666e26",
		label: "Laotian Kip (LAK)",
		value: "LAK",
	},
	{
		uuid: "9fc5d890-c9c6-4762-a000-3f5a88df0873",
		label: "Lebanese Pound (LBP)",
		value: "LBP",
	},
	{
		uuid: "9fc5d890-c9c8-49c8-8da1-725da7339aab",
		label: "Lesotho Loti (LSL)",
		value: "LSL",
	},
	{
		uuid: "9fc5d890-c9c9-49d4-a89e-7e180df4e704",
		label: "Liberian Dollar (LRD)",
		value: "LRD",
	},
	{
		uuid: "9fc5d890-c9ca-45ab-a64d-07e47417824a",
		label: "Libyan Dinar (LYD)",
		value: "LYD",
	},
	{
		uuid: "9fc5d890-c9cc-419b-9ba9-d7f0b7bbd662",
		label: "Macanese Pataca (MOP)",
		value: "MOP",
	},
	{
		uuid: "9fc5d890-c9cd-4784-9d26-1f6b7b5406eb",
		label: "Macedonian Denar (MKD)",
		value: "MKD",
	},
	{
		uuid: "9fc5d890-c9ce-4cc8-80f7-de7599ddf345",
		label: "Malagasy Ariary (MGA)",
		value: "MGA",
	},
	{
		uuid: "9fc5d890-c9d0-477f-b14d-35dc4a9ede54",
		label: "Malawian Kwacha (MWK)",
		value: "MWK",
	},
	{
		uuid: "9fc5d890-c9d1-42e7-9d3b-4f8f99bf2ce3",
		label: "Malaysian Ringgit (MYR)",
		value: "MYR",
	},
	{
		uuid: "9fc5d890-c9d2-4b59-9ae6-164ce2b9ab55",
		label: "Maldivian Rufiyaa (MVR)",
		value: "MVR",
	},
	{
		uuid: "9fc5d890-c9d4-470c-95e5-f8331a919f62",
		label: "Mauritanian Ouguiya (MRO)",
		value: "MRO",
	},
	{
		uuid: "9fc5d890-c9d5-4a84-a6db-94bf2d5e7533",
		label: "Mauritian Rupee (MUR)",
		value: "MUR",
	},
	{
		uuid: "9fc5d890-c9d6-4a1c-aa45-566a4c759975",
		label: "Mexican Peso (MXN)",
		value: "MXN",
	},
	{
		uuid: "9fc5d890-c9d8-49f7-b351-726046a90f6e",
		label: "Moldovan Leu (MDL)",
		value: "MDL",
	},
	{
		uuid: "9fc5d890-c9d9-4173-ac1e-da2bca2b157b",
		label: "Mongolian Tugrik (MNT)",
		value: "MNT",
	},
	{
		uuid: "9fc5d890-c9da-433a-b939-437911ce3938",
		label: "Moroccan Dirham (MAD)",
		value: "MAD",
	},
	{
		uuid: "9fc5d890-c9db-40c0-8bef-68d6954b8175",
		label: "Mozambican Metical (MZN)",
		value: "MZN",
	},
	{
		uuid: "9fc5d890-c9dd-494c-969d-e687f7706798",
		label: "Myanma Kyat (MMK)",
		value: "MMK",
	},
	{
		uuid: "9fc5d890-c9de-48c3-9855-003ee5d2946b",
		label: "Namibian Dollar (NAD)",
		value: "NAD",
	},
	{
		uuid: "9fc5d890-c9df-472d-bdab-b3b7d50f8b10",
		label: "Nepalese Rupee (NPR)",
		value: "NPR",
	},
	{
		uuid: "9fc5d890-c9e1-4f9a-8297-45c47d2660ac",
		label: "Netherlands Antillean Guilder (ANG)",
		value: "ANG",
	},
	{
		uuid: "9fc5d890-c9e2-42d0-884f-d53c00766190",
		label: "New Belarusian Ruble (BYN)",
		value: "BYN",
	},
	{
		uuid: "9fc5d890-c9e3-4459-a25f-111300c1e771",
		label: "New Taiwan Dollar (TWD)",
		value: "TWD",
	},
	{
		uuid: "9fc5d890-c9e5-4fac-b382-1a39f3e79872",
		label: "New Zealand Dollar (NZD)",
		value: "NZD",
	},
	{
		uuid: "9fc5d918-b1a9-4762-8f7a-4bb81ee96d71",
		label: "Nicaraguan Córdoba (NIO)",
		value: "NIO",
	},
	{
		uuid: "9fc5d918-b1b1-4979-abbd-f2d3b2bbc405",
		label: "Nigerian Naira (NGN)",
		value: "NGN",
	},
	{
		uuid: "9fc5d918-b1b4-4bcf-9261-ed91f6de606a",
		label: "Norwegian Krone (NOK)",
		value: "NOK",
	},
	{
		uuid: "9fc5d918-b1b5-48bb-b2df-dd55c1f38707",
		label: "Omani Rial (OMR)",
		value: "OMR",
	},
	{
		uuid: "9fc5d918-b1b7-4237-8477-d8af4b6e8fd4",
		label: "Pakistani Rupee (PKR)",
		value: "PKR",
	},
	{
		uuid: "9fc5d918-b1b9-467f-9c7d-ce8ea35d5c7c",
		label: "Panamanian Balboa (PAB)",
		value: "PAB",
	},
	{
		uuid: "9fc5d918-b1ba-4624-8cd0-925ee450d3b8",
		label: "Papua New Guinean Kina (PGK)",
		value: "PGK",
	},
	{
		uuid: "9fc5d918-b1bc-4832-aa78-96436c4ec59d",
		label: "Paraguayan Guarani (PYG)",
		value: "PYG",
	},
	{
		uuid: "9fc5d918-b1bd-4d9b-9199-12bff02bdd2e",
		label: "Peruvian Nuevo Sol (PEN)",
		value: "PEN",
	},
	{
		uuid: "9fc5d918-b1bf-4d72-9433-13fec63602b9",
		label: "Philippine Peso (PHP)",
		value: "PHP",
	},
	{
		uuid: "9fc5d918-b1c0-4f17-aaf7-5ec541fbf74d",
		label: "Polish Zloty (PLN)",
		value: "PLN",
	},
	{
		uuid: "9fc5d918-b1c2-4a94-a2a8-9a48768786ce",
		label: "Qatari Rial (QAR)",
		value: "QAR",
	},
	{
		uuid: "9fc5d918-b1c3-421b-ae1a-cea60f90f69f",
		label: "Romanian Leu (RON)",
		value: "RON",
	},
	{
		uuid: "9fc5d918-b1c5-4885-8d32-02ef6c5c2cda",
		label: "Russian Ruble (RUB)",
		value: "RUB",
	},
	{
		uuid: "9fc5d918-b1c6-4d27-8b76-8d5dfe4d2dc0",
		label: "Rwandan Franc (RWF)",
		value: "RWF",
	},
	{
		uuid: "9fc5d918-b1c8-42b3-ba3a-272133e94e55",
		label: "Saint Helena Pound (SHP)",
		value: "SHP",
	},
	{
		uuid: "9fc5d918-b1c9-40f6-b1bb-aeb6fd41b0b0",
		label: "Salvadoran Colón (SVC)",
		value: "SVC",
	},
	{
		uuid: "9fc5d918-b1cb-4dec-b7e3-5364b8c212be",
		label: "Samoan Tala (WST)",
		value: "WST",
	},
	{
		uuid: "9fc5d918-b1cc-4735-b455-491ee7a70e59",
		label: "São Tomé & Príncipe Dobra (STD)",
		value: "STD",
	},
	{
		uuid: "9fc5d918-b1ce-41f3-9437-102dead6395c",
		label: "Saudi Riyal (SAR)",
		value: "SAR",
	},
	{
		uuid: "9fc5d918-b1cf-44e1-8665-71bbed19bd56",
		label: "Serbian Dinar (RSD)",
		value: "RSD",
	},
	{
		uuid: "9fc5d918-b1d1-4c19-9be8-2998d936aece",
		label: "Seychellois Rupee (SCR)",
		value: "SCR",
	},
	{
		uuid: "9fc5d918-b1d2-4084-a31f-c170dde8785a",
		label: "Sierra Leonean Leone (SLL)",
		value: "SLL",
	},
	{
		uuid: "9fc5d918-b1d3-4178-8b45-2d821665231e",
		label: "Singapore Dollar (SGD)",
		value: "SGD",
	},
	{
		uuid: "9fc5d918-b1d5-4cb2-a99a-20992f32fc18",
		label: "Solomon Islands Dollar (SBD)",
		value: "SBD",
	},
	{
		uuid: "9fc5d918-b1d6-4bcc-9420-9e9d41ca2822",
		label: "Somali Shilling (SOS)",
		value: "SOS",
	},
	{
		uuid: "9fc5d918-b1d8-445f-9680-47a340a38ea8",
		label: "South African Rand (ZAR)",
		value: "ZAR",
	},
	{
		uuid: "9fc5d918-b1d9-4cf3-8b38-2d297f302f94",
		label: "South Korean Won (KRW)",
		value: "KRW",
	},
	{
		uuid: "9fc5d918-b1da-42f7-8c40-88f1369e10c4",
		label: "Sri Lankan Rupee (LKR)",
		value: "LKR",
	},
	{
		uuid: "9fc5d918-b1de-48da-85f7-7d3b6158028d",
		label: "Sudanese Pound (SDG)",
		value: "SDG",
	},
	{
		uuid: "9fc5d918-b1e0-4c3a-bf5e-2b5d5f2cdea5",
		label: "Surinamese Dollar (SRD)",
		value: "SRD",
	},
	{
		uuid: "9fc5d918-b1e1-4a38-aae6-0027be9febc7",
		label: "Swazi Lilangeni (SZL)",
		value: "SZL",
	},
	{
		uuid: "9fc5d918-b1e3-4f6a-a968-da5fb870af2c",
		label: "Swedish Krona (SEK)",
		value: "SEK",
	},
	{
		uuid: "9fc5d918-b1e4-440c-9c3e-174039d3fcdd",
		label: "Swiss Franc (CHF)",
		value: "CHF",
	},
	{
		uuid: "9fc5d918-b1e5-4bf8-a23b-f47734e050fa",
		label: "Syrian Pound (SYP)",
		value: "SYP",
	},
	{
		uuid: "9fc5d918-b1e7-4c49-8733-116f9b60ed92",
		label: "Tajikistani Somoni (TJS)",
		value: "TJS",
	},
	{
		uuid: "9fc5d918-b1e8-4378-acb5-93492d90a239",
		label: "Tanzanian Shilling (TZS)",
		value: "TZS",
	},
	{
		uuid: "9fc5d918-b1ea-4345-8ce2-e9d60e5d6bf7",
		label: "Thai Baht (THB)",
		value: "THB",
	},
	{
		uuid: "9fc5d918-b1eb-4ddf-8ecd-4c64e3caef9d",
		label: "Tongan Pa'anga (TOP)",
		value: "TOP",
	},
	{
		uuid: "9fc5d918-b1ec-4225-abaa-a0084d09fb00",
		label: "Trinidad & Tobago Dollar (TTD)",
		value: "TTD",
	},
	{
		uuid: "9fc5d918-b1ee-4a3d-acd0-9fb12e26f0c9",
		label: "Tunisian Dinar (TND)",
		value: "TND",
	},
	{
		uuid: "9fc5d918-b1ef-42ca-afd8-8e4a31b78c06",
		label: "Turkish Lira (TRY)",
		value: "TRY",
	},
	{
		uuid: "9fc5d918-b1f0-4b77-8f59-82cc55dc95a9",
		label: "Turkmenistani Manat (TMT)",
		value: "TMT",
	},
	{
		uuid: "9fc5d918-b1f2-4969-854f-309f1550889c",
		label: "Ugandan Shilling (UGX)",
		value: "UGX",
	},
	{
		uuid: "9fc5d918-b1f3-4376-9f5c-bf72b3812e52",
		label: "Ukrainian Hryvnia (UAH)",
		value: "UAH",
	},
	{
		uuid: "9fc5d918-b1f4-4d6e-afc9-7f3289fe21ac",
		label: "United Arab Emirates Dirham (AED)",
		value: "AED",
	},
	{
		uuid: "9fc5d918-b1f6-4132-9b9b-0a98590a4151",
		label: "United States Dollar (USD)",
		value: "USD",
	},
	{
		uuid: "9fc5d918-b1f7-4cfa-a916-38408fba2b29",
		label: "Uruguayan Peso (UYU)",
		value: "UYU",
	},
	{
		uuid: "9fc5d918-b1f8-4fc4-9961-47e1d9e06c50",
		label: "Uzbekistan Som (UZS)",
		value: "UZS",
	},
	{
		uuid: "9fc5d918-b1fa-4d71-9251-ab15635b6b5a",
		label: "Vanuatu Vatu (VUV)",
		value: "VUV",
	},
	{
		uuid: "9fc5d918-b1fb-4187-b5c8-53a7a7493a99",
		label: "Venezuelan Bolívar Fuerte (VEF)",
		value: "VEF",
	},
	{
		uuid: "9fc5d918-b1fc-49f2-8229-a0adf5c89bd5",
		label: "Vietnamese Dong (VND)",
		value: "VND",
	},
	{
		uuid: "9fc5d918-b1fe-4a13-8fa9-f5dd36cd0164",
		label: "Yemeni Rial (YER)",
		value: "YER",
	},
	{
		uuid: "9fc5d918-b1ff-4c4b-97d8-7825479c2c50",
		label: "Zambian Kwacha (ZMW)",
		value: "ZMW",
	},
];
